import axios from 'axios';
import routes from 'app/routes';

export default {
  create: (params, onSuccess, onError) => {
    axios
      .post(routes.api.report_templates.create, params)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  update: (reportTemplateId, params, onSuccess, onError) => {
    axios
      .put(routes.api.report_templates.update(reportTemplateId), params)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  delete: (reportTemplateId, onSuccess) => {
    axios
      .delete(routes.api.report_templates.destroy(reportTemplateId))
      .then((_resp) => {
        onSuccess(reportTemplateId);
      });
  },

  generateReport: (values, onSuccess) => {
    axios
      .get(
        routes.api.report_templates.generate(values.report_template),
        {
          params: {
            title: values.title,
            enterprise_id: values.enterprise,
            teams: values.enterprise_teams,
            plans: values.enterprise_plans,
          },
        },
      )
      .then((response) => {
        onSuccess(response.data);
      })
      .catch((_error) => {
        alert('error');
      });
  },

  getReportStatus: (reportData, onSuccess) => {
    axios
      .get(
        routes.api.report_templates.status,
        {
          params: {
            ...reportData,
          },
        },
      )
      .then((response) => {
        onSuccess(response.data);
      })
      .catch((_error) => {
        alert('error');
      });
  },
};
